import { getProgramApplication, type CurrentUser } from 'Users';
import { type CoachSessionOpportunity } from '../Coach.types';
import { isPostApplicationGoalSettingSessionOpportunity } from './typeGuards';

export function getLaunchableCoachSessionOpportunityForUser(user: CurrentUser | null): CoachSessionOpportunity | null {
    if (!user) return null;

    // In the json, coachSessionOpportunities are ordered with the newest ones last, so we
    // reverse to prefer the newest ones. This has not really been thought through though. Right now.
    // there shouldn't be more than one launchable one anyway
    const coachSessionOpportunity = user.coachSessionOpportunities
        .reverse()
        .find(opportunity => isLaunchable(opportunity, user));

    return coachSessionOpportunity ?? null;
}

function isLaunchable(coachSessionOpportunity: CoachSessionOpportunity, user: CurrentUser): boolean {
    if (coachSessionOpportunity.expired) return false;
    if (coachSessionOpportunity.complete) return false;

    if (isPostApplicationGoalSettingSessionOpportunity(coachSessionOpportunity)) {
        const programApplication = getProgramApplication(user);
        return coachSessionOpportunity.programApplicationId === programApplication?.id;
    }

    throw new Error('Unknown coach session opportunity type');
}
